/* Drawer Cart 6.0: numero persone nella riga social proof.
   Estratto una volta per caricamento di pagina tra data-min e data-max e
   riusato quando il tema ri-renderizza il body del drawer, così non cambia
   sotto gli occhi mentre si aggiungono prodotti. */
class CartSocialCount extends HTMLElement {
  connectedCallback() {
    if (!window.efCartSocialCount) {
      const min = parseInt(this.dataset.min, 10) || 0;
      const max = Math.max(parseInt(this.dataset.max, 10) || min, min);
      window.efCartSocialCount = min + Math.floor(Math.random() * (max - min + 1));
    }
    this.textContent = window.efCartSocialCount;
  }
}
if (!customElements.get('cart-social-count')) customElements.define('cart-social-count', CartSocialCount);
